import type { MaybeRef } from 'vue'
import { SHOULD_USE_GLOBAL_BOUND_KEY } from '@autobid/ui/constants/SHOULD_USE_GLOBAL_BOUND_KEY'

/**
 * useSkipGlobalErrorBoundary is a composable that disables the global error boundary that is used in `App.vue`
 *
 */
export function useSkipGlobalErrorBoundary(enabled: MaybeRef<boolean>) {
  const shouldUse = inject<Ref<boolean>>(
    SHOULD_USE_GLOBAL_BOUND_KEY,
  )

  onMounted(() => {
    if (!unref(enabled) || !shouldUse) {
      return
    }
    shouldUse.value = false
  })
  onUnmounted(() => {
    if (!unref(enabled) || !shouldUse) {
      return
    }
    shouldUse.value = true
  })
}
